import React, { useEffect, useState } from 'react';
function stamp(d: Date): string {
  return d.toISOString().slice(11, 19);
}
export function UtcClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return <time dateTime={now.toISOString()} className="font-mono text-[11px] tabular text-ink" aria-label={`Current time ${stamp(now)} UTC`} data-id="element-454" data-mp="29ivukirmow6f">
      <span className="text-muted" data-id="element-455" data-mp="20jqx7frsz8vu">UTC </span>
      {stamp(now)}
    </time>;
}